import { defineMessages } from "react-intl";
const messages = defineMessages({
    selectAll: {
        id: "app.aiDiscoverability.common.multiSelectDropdown.selectAll",
        defaultMessage: "Select all",
    },
    clearSelection: {
        id: "app.aiDiscoverability.common.multiSelectDropdown.clearSelection",
        defaultMessage: "Clear selection",
    },
    noResults: {
        id: "app.aiDiscoverability.common.multiSelectDropdown.noResults",
        defaultMessage: "No matches found",
    },
});
export default messages;
